import ContextSection from "./components/ContextSection";
import Header from "./components/Header";
import ContactSection from "./components/ContactSection";
import ProjectsSection from "./components/ProjectsSection";
import TeamSection from "./components/TeamSection";
import EndProductSection from "./components/EndProductSection";
import LinkSection from "./components/LinkSection";

const PROJECTS = [
  {
    title: "Concept 1: Headliner",
    descriptionHTML: `Met dit concept willen we effectiever creëren en daarnaast ook nog nieuwe publiek betrekken. De laatste tijd is de aandacht span steeds meer verminderd onder de jongeren. Uit ons onderzoek blijkt dat korte formats, zoals stories en explainer video's op social media, zijn populair bij jongeren. Headliner is een concept waarbij nieuwsgelateerde berichtgeving, zoals documentataires of nieuwsartikelen, worden omgezet in korte, aantrekkelijke video's door middel van Artificial Intelligence.<br/><br />Deze video's worden gedeeld op social media platforms zoals Instagram, TikTok en Snapchat. De video's zijn kort, aantrekkelijk en informatief. Door dit proces zo effectief mogelijk te laten plaatsvinden, ontstaat er consistentie wat goed is voor het algoritme en zo meer jonger kan bereiken`,
    linkableID: "concept-1",
    images: [
      { alt: "Input voor de explainer video", src: "./concept1-1.png" },
      { alt: "Resultaat script, een korte explainer video", src: "./concept1-3.png" },
      {
        alt: "Keuze om een nieuwe video te genereren of de video te exporteren",
        src: "./concept1-2.png",
      },
    ],  
    pros: [
      "Gemakkelijk in gebruik",
      "Effectief doeltreffende content genereren",
    ],
    cons: [
      "Niet altijd even accuraat door AI",
      "Er moet menselijke controle zijn",
      "Het trainen van de AI kost tijd en geld",
    ],
  },
  {
    title: "Concept 2 - Discord bot",
    descriptionHTML: "Discord is een Discord is een platform dat door meer dan 1,5 miljoen mensen in Nederland wordt gebruikt, voornamelijk jongeren. Het staat vooral bekend als een favoriet onder gamers. Terwijl WhatsApp de laatste jaren steeds minder gebruikt wordt. Zien we dat apps zoals Discord, TikTok en Telegram steeds meer terrein winnen.<br/><br />Om de NPO gemakkelijker in contact te laten komen met een doelgroep die minder vaak traditionele media consumeert maar wel regelmatig hun telefoon of computer gebruikt, introduceren we een Discord-bot. Deze bot kan eenvoudig worden toegevoegd aan een Discord-server en stelt gebruikers in staat op de hoogte te blijven van actualiteiten, nieuws en weerberichten, allemaal binnen de vertrouwde omgeving van hun favoriete platform. <br /> <br />Met deze bot willen we ook de interactie met de doelgroep vergroten door dagelijks een vraag van de dag te stellen aan de Discord-gebruikers. Dit zal hen aanmoedigen om actief deel te nemen en het gesprek gaande te houden.",
    linkableID: "concept-2",
    images: [
      { alt: "Discord bot instellingen", src: "./concept2-1.png" },
      {
        alt: "Voorbeeld van een melding van een ingekort nieuwsartikel",
        src: "./concept2-2.png"
      },
      {
        alt: "Voorbeeld van een melding van een nieuw bericht",
        src: "./concept2-3.png"
      },
    ],
    pros: ["Makkelijk te integreren in platform​", "Voegt interactie toe"],
    cons: [
      "Moet ook rekening worden gehouden met een centrale​ website voor dezelfde content",
      "Moderatie van de interactie (eventueel met AI)",
    ],
  },
  {
    title: "Concept 3 - NPO Kennis",
    descriptionHTML: "NPO Kennis is een platform wat, naar aanleiding van ons onderzoek, niet echt bekend is. Desodanks is het format zeer geschikt om jongeren aan te spreken. Wij hebben voor dit platform dan ook een uitbreiding bedacht. Dit is erop gericht om jongeren naar het platform te trekken en ze daar te houden. <br/><br />Stel je voor: je hebt je eigen profielpagina die helemaal over jou gaat. Op die pagina kun je badges verdienen die getoond worden op jouw persoonlijk profiel. Dit doet de gebruiker door quizzen te maken die al op het platform staan. Er wordt gevraagd of zij mee willen doen aan een kleine quiz om een badge te verdienen. Als ze ermee akkoord gaan krijgen ze een mix van open- en multiple choice vragen die gaan over het artikel dat zij lezen. Antwoorden zij deze vragen goed? Dan verdienen ze tokens die je kunt gebruiken om exclusieve afleveringen op NPO Start te kijken. Dit brengt jongeren in aanraaking met de producties van NPO.<br/><br />Naast die badges en tokens, maken we de ervaring op NPO Kennis ook persoonlijker. Op de profielpagina komen er artikelen te staan waarvan we denken dat het bij de gebruiker past, maar we plaatsen er ook af en toe iets waar de gebruiker misschien nog niet eens over nagedacht had.",
    linkableID: "concept-3",
    images: [{ alt: "Homepagina NPO Kennis", src: "./concept3-1.png" },
    { alt: "Artikel NPO Kennis", src: "./concept3-2.png" },
    { alt: "Quiz NPO Kennis", src: "./concept3-3.png" },
    { alt: "Gepersonaliseerde pagina NPO Kennis", src: "./concept3-4.png" },
    { alt: "NPO Start met knop om token in te leveren", src: "./concept3-5.png" },],
    pros: [
      "Te integreren in al een bestaand NPO platform",
      "Brengt jongeren naar het NPO ecosysteem",
      "Persoonlijke pagina",
      "Beloningssysteem",
    ],
    cons: [
      "Content moet meer consistent gepost worden",
      "Quizzes moeten worden​ gemaakt en onderhouden",
    ],
  },
];

export function App() {
  return (
    <>
      <Header />
      <main className="container mx-auto mb-20 px-[15px] ">
        <ContextSection />
        <TeamSection />
        <EndProductSection />
        <ProjectsSection projects={PROJECTS} />
        <LinkSection />
        <ContactSection />
      </main>
    </>
  );
}
